export default __webpack_public_path__ + "static/media/advanced-order-types.0e4f6dac.png";